import { resolveMapProvider } from '~/lib/geo-providers/resolveMapProvider'
import type { GeocodeOutcome } from '~/lib/geo-providers/interfaces'
import { getProviderConfig } from './getProviderConfig'

const geocodeCache = new Map<string, GeocodeOutcome>()

/** Geocode a free-form address through the resolved provider, cached per address for the session. */
export async function geocodeAddress(address: string): Promise<GeocodeOutcome> {
  const key = address.trim().toLowerCase()
  if (!key) return { status: 'unavailable' }

  const cached = geocodeCache.get(key)
  if (cached) return cached

  const { provider } = getProviderConfig()
  if (!provider.accessToken) return { status: 'unavailable' }

  const mapProvider = await resolveMapProvider()
  const outcome = await mapProvider.geocode(address.trim(), provider.accessToken)
  if (outcome.status === 'resolved') geocodeCache.set(key, outcome)
  return outcome
}
